import { useGetChipData } from "../api";
import FindingsDetailsOffCanvas from "./FindingsDetailsOffCanvas";
import { Accordion, Spinner } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import { useEffect } from "react";

const palette = [
  "#56B4E9",
  "#E69F00",
  "#009E73",
  "#F0E442",
  "#0072B2",
  "#D55E00",
  "#CC79A7",
];

const graphOptions = {
  scales: {
    x: {
      title: {
        display: true,
        text: "Raman shift (cm^-1)",
      },
    },
    y: {
      title: {
        display: true,
        text: "Intenisty (a.u.)",
      },
    },
  },
  elements: {
    point: {
      radius: 2,
    },
  },
  plugins: {
    legend: {
      align: "middle",
      display: true,
      labels: {
        boxWidth: 10,
      },
      position: "right",
      onHover: function (e) {
        e.native.target.style.cursor = "pointer";
      },
      onLeave: function (e) {
        e.native.target.style.cursor = "default";
      },
    },
  },
};

function getGraphData(tests) {
  const data = {};

  const xValues = tests[0].wavenumber_plot;
  data.labels = xValues;

  const scanDatasets = tests.map((scan, index) => {
    const paletteIndex = index % palette.length;
    return {
      data: scan.processed_data_plot,
      label: `Round: ${scan.roundId}, Spot: ${scan.spotId}`,
      fill: false,
      borderColor: palette[paletteIndex],
      backgroundColor: palette[paletteIndex],
      pointRadius: 1.5,
    };
  });

  data.datasets = scanDatasets;

  return data;
}

export default function ChipAccordionItem({ id, index, isExpanded, onClick }) {
  const isActive = isExpanded === id;

  const {
    data: chipData,
    isLoading: isChipDataLoading,
    isSuccess: isChipDataSuccess,
    remove: clearChipDataCache,
  } = useGetChipData(id, isActive);

  useEffect(() => {
    if (!isActive) {
      clearChipDataCache();
    }
  }, [isActive, clearChipDataCache]);

  if (isChipDataLoading) {
    return (
      <Accordion.Item eventKey={index.toString()} key={index}>
        <Accordion.Header
          onClick={() => {
            onClick(id);
          }}
        >
          Chip {index + 1}
        </Accordion.Header>
        <Accordion.Body>
          <div className='d-flex justify-content-center align-items-center'>
            <Spinner
              animation='border'
              role='status'
              style={{ width: "2rem", height: "2rem" }}
            />
            <div className='m-3'>Loading...</div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    );
  }
  if (!isChipDataSuccess) {
    return (
      <Accordion.Item eventKey={index.toString()} key={index}>
        <Accordion.Header
          onClick={() => {
            onClick(id);
          }}
        >
          Chip {index + 1}
        </Accordion.Header>
        <Accordion.Body>
          <div className='m-3'>Error fetching chip data</div>
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  if (isChipDataSuccess) {
    const graphData = getGraphData(chipData?.tests || []);
    const allFindings = chipData?.tests
      .filter((scan) => scan.scanType !== "BG")
      .flatMap(
        (scan) => scan.findings.flatMap((finding) => finding.substance) || []
      );
    const uniqueFindings = [...new Set(allFindings)];

    return (
      <Accordion.Item eventKey={index.toString()} key={index}>
        <Accordion.Header
          onClick={() => {
            onClick(id);
          }}
        >
          Chip {index + 1}
        </Accordion.Header>
        <Accordion.Body className='d-flex justify-content-between flex-wrap justify-content-center'>
          <div
            className='d-flex flex-column rounded-3 py-3 px-4 m-2 border shadow flex-grow-1'
            // style={{ backgroundColor: "#E6F7FF" }}
          >
            <div className='h6 mb-3'>Analyte: {chipData.analyte}</div>

            <div className='h6'>Findings:</div>
            {uniqueFindings.length > 0 ? (
              <ul>
                {uniqueFindings.map((finding) => {
                  return <li key={finding}>{finding}</li>;
                })}
              </ul>
            ) : (
              <p>Inconclusive</p>
            )}
            <FindingsDetailsOffCanvas chipData={chipData} index={index} />
          </div>
          <div
            className='align-self-center w-75 m-auto'
            style={{ minWidth: "480px" }}
          >
            <Line data={graphData} options={graphOptions} />
            <p className='text-center text-muted fst-italic mt-2'>
              Click the legend item to view/hide a scan
            </p>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    );
  }
}
